import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fw-bold" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "fw-bold" }

import { ref, computed, watch, onMounted } from "vue";
    import { useStore } from "vuex";
    import { app } from "@/guiide/ts/app";
    import { getAgeAtRetirement } from "@/guiide/ts/utilities";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Survivability',
  emits: ['complete'],
  setup(__props, { emit: __emit }) {

    const emit = __emit;

    const store = useStore();
    const yearsToLiveFromRetirementOn50thPercentile = ref(0);

    onMounted(async () => {
        await getYearsToLiveFromRetirementOnAverage();

        if (store.state.retiree?.survivalPercentile != null) {
            emit("complete");
        }
    });

    watch(
        () => store.state.retiree,
        async (newRetiree) => {
            if (newRetiree == null) {
                return;
            }

            if (newRetiree.survivalPercentile != null) {
                emit("complete");
            } else {
                updateSurvivability();
            }
        },
        { immediate: true }
    );

    const ageAtRetirement = computed<number>(() => getAgeAtRetirement() ?? 0);
    const ageAtDeathOn50thPercentile = computed<number>(() => yearsToLiveFromRetirementOn50thPercentile.value + ageAtRetirement.value);
    const yearsToLiveFromRetirementOnDesignatedPercentile = computed<number>(() => store.state.retiree?.lifeExpectancy ?? 0);
    const ageAtDeathOnDesignatedPercentile = computed<number>(() => yearsToLiveFromRetirementOnDesignatedPercentile.value + ageAtRetirement.value);

    const showSurvivabilitySubSection = computed<boolean>(() => ageAtRetirement.value > 0 && survivalPercentileHasBeenSet.value && averageLifeExpectancyLoaded.value);
    const survivalPercentileHasBeenSet = computed<boolean>(() => store.state.retiree?.survivalPercentile != null);
    const averageLifeExpectancyLoaded = computed<boolean>(() => yearsToLiveFromRetirementOn50thPercentile.value != 0 );

    async function updateSurvivability() {
        if (survivalPercentileHasBeenSet.value) {
            return;
        }

        await app.updateSurvivabilityState();
    }

    async function getYearsToLiveFromRetirementOnAverage() {
        if (averageLifeExpectancyLoaded.value) {
            return;
        }

        const average = await app.getYearsToLiveFromRetirementOn50thSurvivalPercentile();
        yearsToLiveFromRetirementOn50thPercentile.value = average;
    }

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode("On average you may be expected to live to ")),
      _createElementVNode("span", _hoisted_1, _toDisplayString(ageAtDeathOn50thPercentile.value), 1),
      _cache[1] || (_cache[1] = _createTextVNode("."))
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("p", null, "We are required to build you a plan which is expected to last longer than this.", -1)),
    _createElementVNode("p", null, [
      _cache[2] || (_cache[2] = _createTextVNode("There is currently a 25% chance of you living to ")),
      _createElementVNode("span", _hoisted_2, _toDisplayString(ageAtDeathOnDesignatedPercentile.value), 1),
      _cache[3] || (_cache[3] = _createTextVNode("."))
    ]),
    _createElementVNode("p", null, [
      _cache[4] || (_cache[4] = _createTextVNode("Therefore we will build you a plan to expect to last to then. This is ")),
      _createElementVNode("span", _hoisted_3, _toDisplayString(yearsToLiveFromRetirementOnDesignatedPercentile.value), 1),
      _cache[5] || (_cache[5] = _createTextVNode(" years from your retirement date."))
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", null, [
      _createElementVNode("p", null, [
        _createTextVNode(" Life expectancy is complex. The age you are expected to survive to increases as you get older, as you have already made it so far. Therefore it's worth checking this every few years to see if it has increased a little. "),
        _createElementVNode("a", {
          href: "https://www.ons.gov.uk/peoplepopulationandcommunity/birthsdeathsandmarriages/lifeexpectancies",
          target: "_blank"
        }, " Find out more about life expectancy from the ONS. ")
      ])
    ], -1))
  ], 512)), [
    [_vShow, showSurvivabilitySubSection.value]
  ])
}
}

})